<template>
<div class='radio-wrap'>

  <label v-if="!showDetails" class="simple-line radio-label">
    {{delivery.name[lang]}}
  </label>

  <div v-if="showDetails" class="multiple-lines radio-label">
    <label class="radio-label">
      <span class='title'>{{delivery.name[lang]}}</span>
      <span class="delivery-place">{{getAddress()}}</span>
    </label>

  </div>

  <span class="module-price" v-if="shopData.methodPrices">
    {{price}}
  </span>

</div>
</template>

<script>
import Cart from '@/cart'

export default {
  // name: 'customer-pickup-info-panel',
  props: ['delivery', 'showDetails'],
  components: {},
  data() {
    return {
      lang: Cart.lang,
      shopData: Cart.shopData,
      address: this.delivery.data && this.delivery.data.address ? this.delivery.data.address : null,
      methodPrices: Cart.shopData.methodPrices,
      price: '...'
    }
  },
  watch: {
    methodPrices: {
      deep: true,
      handler() {
        this.fillPrice()
      }
    }
  },
  created() {
    console.log('CustomPickupInfoPanel::created', this.delivery)
    this.fillPrice()
  },
  methods: {
    getAddress() {
      return this.address ? this.address.route + ' ' + this.address.street_number + ', ' + this.address.administrative_area_level_1 : ''
    },
    fillPrice() {
      if (Cart.shopData.methodPrices) {
        let code = this.delivery.subCode ? this.delivery.code + '-' + this.delivery.subCode : this.delivery.code
        let priceMinMax = Cart.shopData.methodPrices[code]
        this.price = priceMinMax ? (priceMinMax.n != priceMinMax.x ? priceMinMax.n + ' - ' + priceMinMax.x : priceMinMax.n) + ' Kč' : '-'
      } else {
        this.price = '...'
      }
    }
  }
}
</script>

<style scoped>
</style>
